/* eslint-disable react/prop-types */

/* eslint-disable prettier/prettier */
import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M8 22L10 22L15 13.5L20.5 13.5C21.33 13.5 22 12.83 22 12C22 11.17 21.33 10.5 20.5 10.5L15 10.5L10 2L8 2L10.5 10.5L5 10.5L3.5 8L2 8L3 12L2 16L3.5 16L5 13.5L10.5 13.5L8 22Z",
  fill: "currentColor"
}), 'Airplane', {
  viewBox: '0 0 24 24'
});